export default "__VITE_ASSET__BQaOYydQ__"